import React from 'react';
import PropTypes from 'prop-types';
import withTheme from 'theme/withTheme';
import { Container, Row, Col } from 'react-bootstrap';
import { compose } from 'utils/react';
import { Section } from 'components';
import { BUILDER } from 'shared/abilities';
import stylesGlobal from '../../../theme/facility-globals.scss';
import { section, stylesModal } from '../decorators';
import styles from './HeaderWithTextbox.scss';

const HeaderWithTextbox = ({ children, sectionStyle = {}, theme: { fonts } }) => {
  const [header, textbox, Carousel] = React.Children.toArray(children);

  return (
    <Section
      className={stylesGlobal.section}
      Carousel={Carousel}
      {...sectionStyle}
    >
      <Container>
        <Row className={stylesGlobal.sectionHeader}>
          <Col xs={12} style={{ fontFamily: fonts.primary.name }}>
            {header}
          </Col>
        </Row>
        <Row className={styles.textbox} style={{ fontFamily: fonts.primary.name }}>
          {textbox}
        </Row>
      </Container>
    </Section>
  );
};

HeaderWithTextbox.propTypes = {
  children: PropTypes.node.isRequired,
  sectionStyle: PropTypes.object,
  theme: PropTypes.object.isRequired,
};

const component = compose(
  stylesModal(
    () => ({
      title: 'Header with Textbox Editor',
      initialValues: {},
    }),
  ),
  section(
    { name: 'Header with Textbox', category: 'Text' },
    {
      subsections: [
        { accepts: ['HeaderText'] },
        { accepts: ['ContentBox', 'Accordion'] },
        { accepts: ['Breadcrumbs'] },
      ],
      defaults: [
        'HeaderText',
        'ContentBox',
        'Carousel',
      ],
      menu: {
        items: ['edit', 'delete'],
      },
    },
  ),
  withTheme,
)(HeaderWithTextbox);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
